import React, { useState, useEffect } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ExperienceChart = ({ supplierId }) => {
  const [experience, setExperience] = useState([])

  useEffect(() => {
    fetch(`/rest/v2/supplier/${supplierId}/experience`)
      .then((response) => response.json())
      .then((experience) => {
        if(experience.success){
          setExperience(experience.data.map((yearMonth) => {
            return {
             name: yearMonth.date,
             ...yearMonth.coordinators.reduce((memo, entry) => {
               memo[entry.name] = entry.count
               return memo
             }, {})
            }}))
        }
      }
      
      )
      .catch((error) => window.alert(error))
  }, [supplierId])

    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={experience}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          { Object.keys(experience.reduce((memo, entry) => {
              Object.keys(entry)
              .filter((name) => name !== 'name')
              .forEach((key) => {
                memo[key] = null;
              })
              return memo
            }, {})).map((coordinator, i) => (
              <Bar
                dataKey={coordinator}
                stackId="a"
                fill={["#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7", "#ebdc78"][i] ?? '#326295'}
                />
            ))
          }
        </BarChart>
      </ResponsiveContainer>
    );
  
}

export { ExperienceChart };